import React from 'react';
import { Box, Button, Container, Link, Stack, SxProps, Typography, alpha } from '@mui/material';
import { useLocales } from 'src/locales';
import { paths } from 'src/routes/paths';

interface HeroData {
  title: string;
  subtitle: string;
  description: string;
  button: string;
  image: string;
}
function Hero() {
  const { t } = useLocales();

  const heroData: HeroData = t('heroData', { returnObjects: true });

  return (
    <Container maxWidth="md" sx={{ mt: 3, maxWidth: { xs: '500px', md: 'lg' }, marginTop: 0 }}>
      <Typography variant="overline" sx={{ color: 'text.disabled', py: 3 }}>
        {t('our_product')}
      </Typography>
      <Typography variant="h2" sx={{ mt: 2, mb: 3 }}>
        {t('what_we_have')}
      </Typography>
      <Stack
        direction={{ md: 'row', xs: 'column-reverse' }}
        borderRadius={3}
        spacing={2}
        sx={{
          bgcolor: alpha('#54F4CA', 0.1),
        }}
      >
        <Stack width="100%" justifyContent="center" alignItems="center" sx={{ p: 5 }}>
          <Typography variant="h1" fontSize={{ xs: '3rem', md: '6rem' }}>
            <Box
              component="img"
              src="/assets/pathen.svg"
              alt="pathen"
              width={{ md: '80px', xs: '80px' }}
            />
          </Typography>
          <Typography variant="h2" fontSize={{ xs: '0.8rem', md: '1.5rem' }} letterSpacing={4}>
            {heroData.subtitle}
          </Typography>
          <Typography
            fontSize={{ xs: '0.8rem', md: '1rem' }}
            pl={3}
            sx={{ mt: 3 }}
            position="relative"
          >
            {heroData.description}
            <LightBar
              sx={{
                backgroundColor: '#E56B6F',
                boxShadow: '0px 4px 18.8px 0px #E56B6F;',
              }}
            />
          </Typography>
          <Link href={paths.pathen} target="_blank">
            <Button
              variant="contained"
              sx={{
                mt: 3,
                backgroundColor: '#E56B6F',
                boxShadow: '0px 4px 18.8px 0px #E56B6F',
                px: 3,
                py: 1,
                borderRadius: 10,
                '&:hover': {
                  backgroundColor: 'white',
                  boxShadow: '0px 4px 18.8px 0px #E56B6F',
                  color: '#E56B6F',
                },
              }}
            >
              {heroData.button}
            </Button>
          </Link>
        </Stack>
      </Stack>
    </Container>
  );
}

export default Hero;

function LightBar({ sx }: { sx: SxProps }) {
  return <Box height="100%" width="10px" position="absolute" left={0} top={0} sx={{ ...sx }} />;
}
